import { Stack, Text } from '@mantine/core';
import type { V2Assignee } from 'shared/hooks/use-load-task';

export type TaskAssignee = Pick<V2Assignee, 'id' | 'firstName' | 'lastName'>;

type TaskAssigneesProps = {
  primary: TaskAssignee;
  additional: TaskAssignee[];
};

const fullName = (assignee: TaskAssignee) => `${assignee.firstName} ${assignee.lastName}`;

const AssigneeLine = ({ assignee }: { assignee: TaskAssignee }) => (
  <Text c="gray.10" fw={500} ta="right">
    {fullName(assignee)}
  </Text>
);

export const TaskAssignees = ({ primary, additional }: TaskAssigneesProps) => (
  <Stack gap={2} align="flex-end">
    <AssigneeLine assignee={primary} />
    {additional.map(assignee => (
      <AssigneeLine key={assignee.id} assignee={assignee} />
    ))}
  </Stack>
);
